
import {
  FOTOGRAFIAS_ADD_PHOTO,
  FOTOGRAFIAS_DELETE_PHOTO,
  FOTOGRAFIAS_UPLOAD_PHOTOS,
  FOTOGRAFIAS_STOP_UPLOAD,
  FOTOGRAFIAS_SET_CURRENT_PHOTO,
  FOTOGRAFIAS_SET_RECURSOS_PHOTO,
} from '../../constants/sistemaSubidaFotografias/fotografias.constants';

export const addPhotoAction = (resourceId, base64, endpointUrl = null) => ({
  type: FOTOGRAFIAS_ADD_PHOTO,
  payload: { resourceId, base64, endpointUrl },
});

export const deletePhotoAction = (resourceId, base64) => ({
  type: FOTOGRAFIAS_DELETE_PHOTO,
  payload: { resourceId, base64 },
});

export const uploadPhotosAction = recursosPendientes => ({
  type: FOTOGRAFIAS_UPLOAD_PHOTOS,
  payload: { recursosPendientes },
});

export const endUploadingPhotosAction = () => ({
  type: FOTOGRAFIAS_STOP_UPLOAD,
});

export const setCurrentPhotoAction = currentPhoto => ({
  type: FOTOGRAFIAS_SET_CURRENT_PHOTO,
  payload: { currentPhoto },
});

export const discardCurrentPhotoAction = () => ({
  type: FOTOGRAFIAS_SET_CURRENT_PHOTO,
  payload: { currentPhoto: undefined },
});

export const discardAllPhotosAction = () => ({
  type: FOTOGRAFIAS_SET_RECURSOS_PHOTO,
  payload: { recursos: [] },
});
